import { api } from "../base";

// Decimal fields arrive as strings over JSON (Rust `Decimal` serializes as a
// string to preserve precision), so they are typed `string` here and parsed
// with `toNumber` on the consumer side — matching Trade.

/** Pricing state of an asset row; mirrors why the pre-trade check would block. */
export type ExposurePriceStatus =
  | "priced"
  | "stale_fx"
  | "no_price"
  | "stale_price"
  | "wide_spread"
  | "no_fx";

/** One asset subrow under a counterparty: signed position + USD bbo/mid/notional. */
export interface AssetExposure {
  asset: string;
  signed_qty: string;
  bid?: string | null;
  ask?: string | null;
  mid?: string | null;
  notional?: string | null;
  source_quote?: string | null;
  status: ExposurePriceStatus;
  status_message?: string | null;
}

/** A counterparty parent row: USD limit, gross notional, and per-asset subrows. */
export interface CounterpartyExposure {
  counterparty: string;
  exposure_limit?: string | null;
  total_gross_notional: string;
  assets: AssetExposure[];
}

/** Snapshot of current risk exposure by counterparty from trading-ops-server. */
export interface RiskExposureResponse {
  as_of: string;
  quote_currency: string;
  counterparties: CounterpartyExposure[];
}

const riskExposureEndpoints = api.injectEndpoints({
  endpoints: (build) => ({
    getRiskExposure: build.query<RiskExposureResponse, void>({
      query: () => ({
        url: "/api/trading-ops/v1/risk-exposure",
      }),
    }),
  }),
});

export const { useGetRiskExposureQuery } = riskExposureEndpoints;
